import {defineMessages} from 'react-intl';

export default defineMessages({
	emailLabel: {
		id: 'forms.fields.email.labels.optional',
		defaultMessage: 'Email',
	},
	emailNotFound: {
		id: 'forms.fields.email.noempty',
		defaultMessage: 'Please enter your email address',
	},
	emailIsInvalid: {
		id: 'forms.fields.email.noinvalid',
		defaultMessage: 'Please enter a valid email address',
	},
	firstNameLabel: {
		id: 'forms.fields.firstName.placeholder',
		defaultMessage: 'First Name',
	},
	lastNameLabel: {
		id: 'forms.fields.lastName.placeholder',
		defaultMessage: 'Last Name',
	},
	passwordLabel: {
		id: 'forms.fields.password.placeholder',
		defaultMessage: 'Password',
	},
	passwordNotFound: {
		id: 'forms.fields.password.noempty',
		defaultMessage: 'Please enter your password',
	},
	passwordSpecialCharsMinLength: {
		id: 'forms.fields.password.error.specialCharsMinLength',
		defaultMessage: 'Please enter at least {minSpecialChars} special character',
	},
	passwordErrorLetters: {
		id: 'forms.fields.password.error.letters',
		defaultMessage: 'Please enter at least 1 letter',
	},
	passwordErrorMixedLetters: {
		id: 'forms.fields.password.error.mixedLetters',
		defaultMessage: 'Please enter at least 1 letter uppercase and 1 letter lowercase',
	},
	passwordErrorNumbers: {
		id: 'forms.fields.password.error.numbers',
		defaultMessage: 'Please enter at least 1 number',
	},
	passwordErrorLength: {
		id: 'forms.fields.password.error.length',
		defaultMessage: 'Password should have from {minLength} to {maxLength} characters',
	},
	passwordErrorGeneral: {
		id: 'forms.fields.password.error.general',
		defaultMessage: 'Password error',
	},
	birthdayLabel: {
		id: 'forms.fields.birthday.label',
		defaultMessage: 'Date of birth<required>*</required>',
	},
	birthdayErrorInvalid: {
		id: 'forms.fields.birthday.error.invalid',
		defaultMessage: 'Please enter the correct date',
	},
	phonePlaceholder: {
		id: 'forms.fields.phoneNumber.placeholder',
		defaultMessage: 'Phone',
	},
	phoneLabel: {
		id: 'forms.fields.phoneNumber.label',
		defaultMessage: 'Phone',
	},

	titleLabel: {
		id: 'forms.fields.title.labels.required',
		defaultMessage: 'Title<required>*</required>',
	},
	titleFemale: {
		id: 'forms.fields.title.female',
		defaultMessage: 'Mrs.',
	},
	titleMale: {
		id: 'forms.fields.title.male',
		defaultMessage: 'Mr.',
	},
	titleMask: {
		id: 'forms.fields.title.mask',
		defaultMessage: '--',
	},
});
